// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CKIg","clinicsSelect":"styles_clinicsSelect__2bpy3"};